/**
 * Quick and Dirty clone(). Doesn't clone methods.
 * @param obj
 * @returns {any}
 */
export function clone (obj) {
  return JSON.parse(JSON.stringify(obj));
}
